import React, { useEffect, useState } from "react";
import { MarketingNavbarComponent } from "../Components/navbar/marketingnav";
import axiosConfig from "../Service/axiosConfig";
import DataTable from 'react-data-table-component';
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
import { MdCheck, MdClose } from "react-icons/md";
import { PopupModal } from "../Components";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";

const AccountDeletionRequests = () => {
    const [Data, SetData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [popupType, setpopupType] = useState("");
    const [Message, setMessage] = useState("");
    // added
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
    const [RowId, SetRowId] = useState(null);
    const [actionType, setActionType] = useState("");

    const GetData = async () => {
        setLoading(true);
        try {
            const url = `/user_data/account-deletion-requests/`;
            const response = await axiosConfig.get(url);
            console.log(response);
            SetData(response.data.results || response.data);
            setTotalRows(response.data.count || response.data.length);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    useEffect(() => {
        GetData();
    }, [currentPage, RowPerPage]);

    const handleSort = (column, direction) => {
        console.log(column.selector, direction);
        setCurrentPage(1);
    };

    // approve popup
    const handleApprove = (id) => {
        SetRowId(id);
        setActionType("approve");
        setMessage("Are you sure you want to approve this request?");
        SetAlertDeletePopupType("success");
    };

    // reject popup
    const handleReject = (id) => {
        SetRowId(id);
        setActionType("reject");
        setMessage("Are you sure you want to reject this request?");
        SetAlertDeletePopupType("success");
    };

    // close popup
    const CancelAlerrt = () => {
        SetAlertDeletePopupType("");
    };

    // confirm action
    const HandleDelete = async (id) => {
        try {

            if (actionType === "approve") {
                await axiosConfig.post(
                    `/user_data/account-deletion-requests/${id}/approve/`
                );
            } else {
                await axiosConfig.post(
                    `/user_data/account-deletion-requests/${id}/reject/`
                );
            }
            if (actionType === "approve") {
                setMessage("Request approved successfully!");
            } else {
                setMessage("Request rejected successfully!");
            }
            setpopupType("success");

            // update status immediately
            SetData((prev) =>
                prev.map((item) =>
                    item.id === id
                        ? {
                            ...item,
                            status:
                                actionType === "approve"
                                    ? "Approved"
                                    : "Rejected",
                        }
                        : item
                )
            );

            SetAlertDeletePopupType("");

        } catch (error) {
            console.log(error);
            setpopupType("error");
            SetAlertDeletePopupType("");
        }
    };

    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
            sortable: false,
        },
        {
            name: "User ID",
            selector: "user",
            sortable: true,
            cell: row => row.user,
        },
        {
            name: "Email",
            selector: "email",
            sortable: true,
            cell: row => row.email || row.user_email || "N/A",
        },
        {
            name: "Reason",
            selector: "reason",
            sortable: true,
            cell: row => row.reason || "N/A",
        },
        {
            name: "Status",
            selector: "status",
            sortable: true,
            cell: row => (
                <span className={`badge ${row.status === 'Pending'
                    ? 'bg-warning'
                    : row.status === 'Approved'
                        ? 'bg-success'
                        : 'bg-danger'
                    }`}>
                    {row.status}
                </span>
            ),
        },
        {
            name: "Requested Date",
            selector: "created_at",
            sortable: true,
            cell: row => new Date(row.created_at).toLocaleDateString(),
        },
        {
            width: "300px",
            name: "ACTIONS",
            cell: row => {

                // after approve/reject show -
                if (row.status !== "Pending") {
                    return <span>-</span>;
                }

                return (
                    <div className="row">
                        <div className="table-actions" style={{ display: 'flex', gap: '10px' }}>
                            <button
                                className="action-btn edit-btn"
                                onClick={() => handleApprove(row.id)}
                            >
                                <MdCheck className="dashboard-tabe-data-actions" /> Approve
                            </button>

                            <button
                                className="action-btn delete-btn"
                                onClick={() => handleReject(row.id)}
                            >
                                <MdClose className="dashboard-tabe-data-actions" /> Reject
                            </button>
                        </div>
                    </div>
                );
            }
        }
    ];

    return (
        <div className="child-sidenav">
            <MarketingNavbarComponent />

            <div className="childnav-content">
                <div className="d-flex align-items-center mb-3">
                    <h4 className="m-0">Account Deletion Requests</h4>
                </div>

                <div className="table-responsive marginTop">
                    <DataTable
                        columns={columns}
                        data={Data}
                        pagination
                        paginationTotalRows={totalRows}
                        paginationPerPage={RowPerPage}
                        paginationDefaultPage={currentPage}
                        onChangePage={(page) => setCurrentPage(page)}
                        paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                        paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                        onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                        onSort={handleSort}
                        paginationServer
                        fixedHeader
                        subHeader
                        customStyles={tableCustomStyles}
                        progressPending={loading}
                        progressComponent={
                            <div className="loader-container">
                                <img
                                    src={require('../Components/FormParser/images/loader2.gif')}
                                    alt="Loading..."
                                />
                            </div>
                        }
                    />
                </div>

                {/* confirmation popup */}
                {AlertDeletePopupType === "success" && (
                    <AlertDeletePopupModal
                        // AlertDeletePopupType={AlertDeletePopupType}
                        // HandleDelete={HandleDelete}
                        // CancelAlerrt={CancelAlerrt}
                        // row={RowId}
                        AlertDeletePopupType={AlertDeletePopupType}
                        HandleDelete={HandleDelete}
                        CancelAlerrt={CancelAlerrt}
                        row={RowId}
                        Message={Message}
                    />
                )}

                {/* success/error popup */}
                <div>
                    {popupType !== "" &&
                        <PopupModal
                            // setpopupType={setpopupType}
                            // popupType={popupType}
                            // Navigation=""
                            setpopupType={setpopupType}
                            popupType={popupType}
                            Navigation=""
                            Message={Message}
                            setMessage={setMessage}
                        />
                    }
                </div>
            </div>
        </div>
    );
};

export { AccountDeletionRequests };